import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    id: String,
    open: { type: Boolean, default: false }
  }

  static targets = ["autofocus"]

  connect() {
    this.boundHandleToggle = this.handleToggle.bind(this)
    window.addEventListener("flyout:toggle", this.boundHandleToggle)

    if (this.openValue) this.openValueChanged()
  }

  disconnect() {
    window.removeEventListener("flyout:toggle", this.boundHandleToggle)
  }

  handleToggle(event) {
    const targetId = event.detail.id
    if (targetId === this.idValue) {
      this.toggle()
    } else {
      if (this.openValue && event.detail.exclusive) {
        this.close()
      }
    }
  }

  toggle() {
    this.openValue = !this.openValue
  }

  close() {
    this.openValue = false
  }

  openValueChanged() {
    // Check if the element is rendered (not hidden by responsive classes like lg:hidden).
    // We use getComputedStyle because offsetParent returns null for position:fixed elements.
    const isVisible = getComputedStyle(this.element).display !== 'none'

    if (this.openValue) {
      this.element.classList.add("open")
      // Only lock body scroll if the flyout is actually visible (e.g., Mobile)
      if (isVisible) {
        document.body.classList.add("overflow-hidden")
      }
      if (this.hasAutofocusTarget) {
        requestAnimationFrame(() => this.autofocusTarget.focus())
      }
    } else {
      this.element.classList.remove("open")

      const openFlyouts = document.querySelectorAll('[data-controller="flyout"].open')
      if (openFlyouts.length === 0) {
        document.body.classList.remove("overflow-hidden")
      }
    }
  }
}
